export default ({ style }) => (
  <svg width="199" height="220" viewBox="0 0 199 220" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path
      d="M28 105C28.3932 109.798 32.2016 113.607 36.9998 114C32.2016 114.393 28.3932 118.201 28 123C27.6068 118.201 23.7984 114.393 19.0002 114C23.7984 113.607 27.6068 109.798 28 105Z"
      fill="#FFBD39"
    />
    <path
      d="M180 61.9996C180.481 67.8643 185.136 72.5192 191 72.9998C185.136 73.4804 180.481 78.1353 180 84C179.519 78.1353 174.864 73.4804 169 72.9998C174.864 72.5192 179.519 67.8643 180 61.9996Z"
      fill="#EB5757"
    />
    <path
      d="M127 12C127.262 15.1989 129.801 17.738 133 18.0001C129.801 18.2622 127.262 20.8013 127 24.0002C126.738 20.8013 124.199 18.2622 121 18.0001C124.199 17.738 126.738 15.1989 127 12Z"
      fill="#3C52EF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.4828 175.401L155.202 144.503L174.852 179.939C174.856 179.946 174.86 179.954 174.864 179.961C177.657 184.996 167.447 195.995 152.061 204.527C136.674 213.059 121.937 215.894 119.145 210.858C119.145 210.858 119.145 210.858 119.145 210.858L119.145 210.858L99.4828 175.401Z"
      fill="#4162FF"
    />
    <ellipse
      cx="31.8563"
      cy="10.4257"
      rx="31.8563"
      ry="10.4257"
      transform="matrix(-0.874541 0.484952 0.484952 0.874541 150.146 135.385)"
      fill="#08033B"
    />
    <mask id="mask0_54_816" mask-type="alpha" maskUnits="userSpaceOnUse" x="79" y="31" width="83" height="147">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.691 31.2182L143.272 43.3875L161.628 86.2026L147.707 123.738L155.202 144.503L155.201 144.503C157.993 149.539 147.784 160.538 132.398 169.07C117.011 177.602 102.274 180.436 99.4821 175.401C99.3842 175.224 99.3023 175.041 99.2361 174.85L81.4352 135.036L79.6085 78.2965L79.3589 56.9969L88.6114 41.134L108.305 31.1655L131.691 31.2182Z"
        fill="#FF9A41"
      />
    </mask>
    <g mask="url(#mask0_54_816)">
      <path
        d="M93.6961 55.2899L93.445 107.738C93.3613 125.228 97.4475 142.485 105.365 158.081L114.835 176.736"
        stroke="#F8BCBC"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
      <path
        d="M105.038 45.4976L104.787 97.9455C104.703 115.435 108.789 132.693 116.706 148.288L126.177 166.944"
        stroke="#F8BCBC"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
      <path
        d="M118.376 42.0861L118.125 94.5341C118.041 112.024 122.127 129.282 130.045 144.877L139.515 163.532"
        stroke="#F8BCBC"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
      <path
        d="M130.511 47.9363L130.26 100.384C130.177 117.874 134.263 135.132 142.18 150.727L151.65 169.382"
        stroke="#F8BCBC"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
      <path
        d="M126.026 39.7315V39.7315C124.889 41.6265 124.288 43.7949 124.288 46.0049L124.288 88.8873"
        stroke="#EC8686"
        strokeWidth="1.73762"
        strokeLinecap="round"
      />
      <path
        d="M109.808 38.5731V38.5731C108.671 40.4681 108.071 42.6365 108.071 44.8465L108.071 86.4665"
        stroke="#EC8686"
        strokeWidth="1.73762"
        strokeLinecap="round"
      />
      <path
        d="M95.3277 46.682V46.682C94.1907 48.577 93.5901 50.7454 93.5901 52.9554L93.5901 90.4169"
        stroke="#EC8686"
        strokeWidth="1.73762"
        strokeLinecap="round"
      />
      <path
        d="M148.861 86.5417V86.5417C140.318 97.82 135.385 111.418 134.709 125.551L134.459 130.783"
        stroke="#F8BCBC"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.5172 163.401L43.7979 132.503L24.1479 167.939C24.1438 167.946 24.1398 167.954 24.1357 167.961C21.3434 172.996 31.553 183.995 46.9394 192.527C62.3259 201.059 77.0627 203.894 79.855 198.858C79.855 198.858 79.8551 198.858 79.8551 198.858L79.8551 198.858L99.5172 163.401Z"
      fill="#4162FF"
    />
    <ellipse
      cx="71.6572"
      cy="147.952"
      rx="31.8563"
      ry="10.4257"
      transform="rotate(29.0093 71.6572 147.952)"
      fill="#08033B"
    />
    <mask id="mask1_54_816" mask-type="alpha" maskUnits="userSpaceOnUse" x="37" y="19" width="83" height="147">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.3091 19.2182L55.7275 31.3875L37.3723 74.2026L51.2932 111.738L43.7982 132.503L43.7985 132.503C41.0066 137.539 51.2161 148.538 66.6023 157.07C81.9888 165.602 96.7256 168.436 99.5179 163.401C99.6158 163.224 99.6977 163.041 99.7639 162.85L117.565 123.036L119.391 66.2965L119.641 44.9969L110.389 29.134L90.6953 19.1655L67.3091 19.2182Z"
        fill="#FF9A41"
      />
    </mask>
    <g mask="url(#mask1_54_816)">
      <path
        d="M105.304 43.2899L105.555 95.7378C105.638 113.228 101.552 130.485 93.6351 146.081L84.1645 164.736"
        stroke="#FFD0C2"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
      <path
        d="M93.9624 33.4975L94.2134 85.9455C94.2971 103.435 90.211 120.693 82.2938 136.288L72.8231 154.944"
        stroke="#FFD0C2"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
      <path
        d="M80.624 30.0861L80.875 82.534C80.9587 100.024 76.8726 117.282 68.9554 132.877L59.4848 151.532"
        stroke="#FFD0C2"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
      <path
        d="M68.4885 35.9363L68.7395 88.3842C68.8232 105.874 64.7371 123.132 56.8199 138.727L47.3493 157.382"
        stroke="#FFD0C2"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
      <path
        d="M71.7117 27.7315V27.7315C70.5747 29.6265 69.9741 31.7949 69.9741 34.0049L69.9741 81.8873"
        stroke="#EB8E8E"
        strokeWidth="1.73762"
        strokeLinecap="round"
      />
      <path
        d="M87.9295 26.5731V26.5731C86.7925 28.4681 86.1919 30.6365 86.1919 32.8465L86.1919 82.4665"
        stroke="#EB8E8E"
        strokeWidth="1.73762"
        strokeLinecap="round"
      />
      <path
        d="M102.41 34.682V34.682C101.273 36.577 100.672 38.7454 100.672 40.9554L100.672 89.4169"
        stroke="#EB8E8E"
        strokeWidth="1.73762"
        strokeLinecap="round"
      />
      <path
        d="M50.1387 74.5417V74.5417C58.682 85.82 63.6154 99.4181 64.291 113.551L64.5411 118.783"
        stroke="#FFD0C2"
        strokeWidth="18.5346"
        strokeLinecap="round"
      />
    </g>
    <path d="M59.4678 15.648L53.02 4" stroke="#EA7676" strokeWidth="3" strokeLinecap="round" />
    <path d="M153.617 36.04L157.514 29" stroke="#3CCFEF" strokeWidth="3" strokeLinecap="round" />
    <path d="M151.02 59.648L157.468 48" stroke="#8FB4FF" strokeWidth="3" strokeLinecap="round" />
    <path d="M43.5602 44.6568L30.9648 40.3432" stroke="#97FFBA" strokeWidth="3" strokeLinecap="round" />
    <path d="M48.0256 25.7462L26 7.94519" stroke="#FFBD39" strokeWidth="3" strokeLinecap="round" />
  </svg>
)
